<template>
    <div id="app" :style="cssVars">
        <router-view/>
    </div>
</template>

<style src='./assets/fonts/fontawesome/css/all.css'></style>
<script>
    import {mapGetters} from "vuex";

    export default {
        computed: {
            ...mapGetters("app", ['getDefaultColor']),

            cssVars() {
                return {
                    '--default-color': this.getDefaultColor
                }
            }
        },
        created() {
            console.log('Node Env: ' + process.env.NODE_ENV);
            console.log('BackEnd Url: ' + process.env.VUE_APP_BACKEND_URL);
        },
    };
</script>

<style lang="scss">
    @import 'bootstrap.css';

    body {
        padding-right: 0 !important;
        max-height: 100vh;
        overflow-y: hidden;
    }

    #app {
        height: 100vh;
    }

    #app a:focus {
        box-shadow: none;
    }

    .body-wrapper {
        height: 100vh;
    }

    .custom-loader {
        z-index: 99999 !important;
    }

    .vb .vb-dragger {
        z-index: 5;
        width: 12px;
        right: 0;
    }

    .vb .vb-dragger .vb-dragger-styler {
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-transform: rotate3d(0, 0, 0, 0);
        transform: rotate3d(0, 0, 0, 0);
        -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out,
        height 100ms ease-out;
        transition: background-color 100ms ease-out, margin 100ms ease-out,
        height 100ms ease-out;
        background-color: rgba(86, 86, 86, 0.1);
        margin: 5px 5px 5px 0;
        border-radius: 20px;
        height: calc(100% - 10px);
        display: block;
    }

    .vb.vb-scrolling-phantom .vb-dragger .vb-dragger-styler {
        background-color: rgba(86, 86, 86, 0.3);
    }

    .vb .vb-dragger:hover .vb-dragger-styler {
        background-color: rgba(86, 86, 86, 0.5);
        margin: 0px;
        height: 100%;
    }

    .vb.vb-dragging .vb-dragger .vb-dragger-styler {
        background-color: rgba(86, 86, 86, 0.5);
        margin: 0px;
        height: 100%;
    }

    .vb.vb-dragging-phantom .vb-dragger .vb-dragger-styler {
        background-color: rgba(86, 86, 86, 0.5);
    }

    button:focus {
        outline: none;
    }

    .input-wrapper {
        max-width: 100%;
    }

    /**** filter checkbox ****/
    .btn-switch {
        border: 1px solid lightgray;
    }

    .switch {
        position: absolute;
        display: inline-block;
        width: 37px;
        height: 21px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 2px;
        left: 0;
        right: 0;
        bottom: -2px;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 14px;
        width: 14px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: var(--default-color);
    }

    input:focus + .slider {
        box-shadow: 0 0 1px var(--default-color);
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(15px);
        -ms-transform: translateX(158px);
        transform: translateX(15px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    .switch-label {
        margin-left: calc(37px + 5px);
    }

    /**** Smooth-Form ****/

    * {
        transition: 0.3s;
    }

    input {
        height: 38px !important;
        border: 1px solid #ced4da;
    }

    label {
        position: absolute;
        color: #999;
        padding: 4px 6px;
    }

    textarea {
        display: block;
        resize: vertical;
        border: 1px solid #ced4da;
    }

    input::placeholder, textarea::placeholder {
        color: transparent !important;
    }

    .go-bottom {
        height: 45px;
    }

    .smooth-form-group {
        position: relative;
    }

    .form-group:focus-within .smooth-label,
    .form-group.filled .smooth-label {
        background: var(--default-color);
        color: white;
        font-size: 70%;
        padding: 0px 6px;
        text-transform: uppercase;
        height: 16px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        bottom: -8px;
    }
    .form-group:focus-within .smooth-label-text-area,
    .form-group.filled .smooth-label-text-area {
        background: var(--default-color);
        color: white;
        font-size: 70%;
        padding: 0px 6px;
        text-transform: uppercase;
        height: 16px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        bottom: -23px;
    }

    .smooth-label {
        left: 0;
        width: 100%;
        pointer-events: none;
        -webkit-transition: 0.3s;
        transition: 0.3s;
        bottom: -3px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .smooth-label-text-area {
        left: 0;
        width: 100%;
        pointer-events: none;
        -webkit-transition: 0.3s;
        transition: 0.3s;
        bottom: -35px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }


    .form-group:focus-within input, .form-group:focus-within textarea,
    .form-group.filled input, .form-group.filled input {
        padding: 4px 6px 20px 5px;
        box-shadow: none;
    }

    /*.fix-smooth-label{*/
    /*    top: calc(100% - 39px);*/
    /*    height: 16px;*/
    /*    border-bottom-left-radius: 3px;*/
    /*    border-bottom-right-radius: 3px;*/
    /*    background: var(--default-color);*/
    /*    color: white;*/
    /*    font-size: 70%;*/
    /*    padding: 0px 6px;*/
    /*    z-index: 2;*/
    /*    text-transform: uppercase;*/
    /*    width: calc(100% - 30px);*/
    /*}*/

    .vue-tel-input {
        height: 38px;
        border: 1px solid #ced4da;
        transition: 0.3s;
    }

    .vue-tel-input input {
        height: 36px !important;
    }

    .form-group.filled .vue-tel-input,
    .vue-tel-input:focus-within {
        padding-bottom: 13px;
    }

    .vue-tel-input .dropdown {
        outline: none !important;
    }

    .vue-tel-input ::v-deep .dropdown.open ul {
        margin-top: -12px;
    }

    .vue-tel-input .dropdown:focus {
        outline: none;
    }

    .vue-tel-input + .smooth-label {
        padding-left: 60px;
    }

    .vue-tel-input >>> input::placeholder {
        color: transparent;
    }

    .header-label {
        position: relative;
        height: 19px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        background: var(--default-color);
        color: white;
        font-size: 70%;
        padding: 1px 6px;
        z-index: 2;
        text-transform: uppercase;
        width: 100%;
        margin-bottom: 0px;
    }

    .smooth-label.required:before {
        content: " *";
        color: red;
    }

    #drug-select-modal > div {
        max-width: 90%;
    }
    #appointmentDialog > div {
        max-width: 95%;
    }
    #drug-select-modal-v2 > div {
        max-width: 90%;
    }

    #patientBasicDataDialog > div {
        max-width: 95%;
    }

    #getPatientDialog > div {
        max-width: 70%;
    }
    #patient-select-modal > div {
        max-width: 75%;
    }
    .collapsed i {
        transform: rotate(90deg);
    }

    // BNOPopup styles
    .bno-badges-container {
        flex-basis: 100%;
        position: relative;
        border: 1px solid #ced4da;
        border-radius: 0.2rem 0 0 0.2rem;
        padding: 2px 2px 18px 2px;

        &:focus-visible {
            outline: none;
            border-color: #80bdff
        }

        .placeholder {
            color: #a2a2a2;
            padding: 3px 3px 0 3px;
        }

        .badge {
            padding: 7px 0 7px 7px;
            margin: 3px;
        }

        .badge-remove {
            border-left: 1px solid #136d7b;
            margin-left: 3px;
            margin-right: 3px;
            padding: 0 8px;
            cursor: pointer;
            &:hover {
                color: #136d7b;
            }
        }
    }
    .packages-container{
        flex-basis: 100%;
        position: relative;
        border: 1px solid #ced4da;
        border-radius: 0.2rem 0 0 0.2rem;
        padding: 2px 2px 18px 2px;

        &:focus-visible {
            outline: none;
            border-color: #80bdff
        }

        .placeholder {
            color: #a2a2a2;
            padding: 3px 3px 0 3px;
        }

        .badge {
            padding: 7px 0 7px 7px;
            margin: 3px;
        }

        .badge-remove {
            border-left: 1px solid #136d7b;
            margin-left: 3px;
            margin-right: 3px;
            padding: 0 8px;
            cursor: pointer;
            &:hover {
                color: #136d7b;
            }
        }
    }
    .laboratory-types-container{
        flex-basis: 100%;
        position: relative;
        border: 1px solid #ced4da;
        border-radius: 0.2rem 0 0 0.2rem;
        padding: 2px 2px 18px 2px;

        &:focus-visible {
            outline: none;
            border-color: #80bdff
        }

        .placeholder {
            color: #a2a2a2;
            padding: 3px 3px 0 3px;
        }

        .badge {
            padding: 7px 0 7px 7px;
            margin: 3px;
        }

        .badge-remove {
            border-left: 1px solid #136d7b;
            margin-left: 3px;
            margin-right: 3px;
            padding: 0 8px;
            cursor: pointer;
            &:hover {
                color: #136d7b;
            }
        }
    }
    .illness-badges-container{
        flex-basis: 100%;
        position: relative;
        border: 1px solid #ced4da;
        border-radius: 0.2rem 0 0 0.2rem;
        padding: 2px 2px 18px 2px;

        &:focus-visible {
            outline: none;
            border-color: #80bdff
        }

        .placeholder {
            color: #a2a2a2;
            padding: 3px 3px 0 3px;
        }

        .badge {
            padding: 7px 0 7px 7px;
            margin: 3px;
        }

        .badge-remove {
            border-left: 1px solid #136d7b;
            margin-left: 3px;
            margin-right: 3px;
            padding: 0 8px;
            cursor: pointer;
            &:hover {
                color: #136d7b;
            }
        }
    }
    .restriction-badges-container{
        flex-basis: 100%;
        position: relative;
        border: 1px solid #ced4da;
        border-radius: 0.2rem 0 0 0.2rem;
        padding: 2px 2px 18px 2px;

        &:focus-visible {
            outline: none;
            border-color: #80bdff
        }

        .placeholder {
            color: #a2a2a2;
            padding: 3px 3px 0 3px;
        }

        .badge {
            padding: 7px 0 7px 7px;
            margin: 3px;
        }

        .badge-remove {
            border-left: 1px solid #136d7b;
            margin-left: 3px;
            margin-right: 3px;
            padding: 0 8px;
            cursor: pointer;
            &:hover {
                color: #136d7b;
            }
        }
    }
    .discounts-container{
        flex-basis: 100%;
        position: relative;
        border: 1px solid #ced4da;
        border-radius: 0.2rem 0 0 0.2rem;
        padding: 2px 2px 18px 2px;

        &:focus-visible {
            outline: none;
            border-color: #80bdff
        }

        .placeholder {
            color: #a2a2a2;
            padding: 3px 3px 0 3px;
        }

        .badge {
            padding: 7px 0 7px 7px;
            margin: 3px;
        }

        .badge-remove {
            border-left: 1px solid #136d7b;
            margin-left: 3px;
            margin-right: 3px;
            padding: 0 8px;
            cursor: pointer;
            &:hover {
                color: #136d7b;
            }
        }
    }
    .medication-badges-container{
        flex-basis: 100%;
        position: relative;
        border: 1px solid #ced4da;
        border-radius: 0.2rem 0 0 0.2rem;
        padding: 2px 2px 18px 2px;

        &:focus-visible {
            outline: none;
            border-color: #80bdff
        }

        .placeholder {
            color: #a2a2a2;
            padding: 3px 3px 0 3px;
        }

        .badge {
            padding: 7px 0 7px 7px;
            margin: 3px;
        }

        .badge-remove {
            border-left: 1px solid #136d7b;
            margin-left: 3px;
            margin-right: 3px;
            padding: 0 8px;
            cursor: pointer;
            &:hover {
                color: #136d7b;
            }
        }
    }
    .patient-badges-container{
        flex-basis: 100%;
        position: relative;
        border: 1px solid #ced4da;
        border-radius: 0.2rem 0 0 0.2rem;
        padding: 2px 2px 18px 2px;

        &:focus-visible {
            outline: none;
            border-color: #80bdff
        }

        .placeholder {
            color: #a2a2a2;
            padding: 3px 3px 0 3px;
        }

        .badge {
            padding: 7px 0 7px 7px;
            margin: 3px;
        }

        .badge-remove {
            border-left: 1px solid #136d7b;
            margin-left: 3px;
            margin-right: 3px;
            padding: 0 8px;
            cursor: pointer;
            &:hover {
                color: #136d7b;
            }
        }
    }

    .search-icon-wrapper {
        height: auto;
        padding: 0.25rem 0.5rem;
        border-top: 1px solid #ced4da;
        border-right: 1px solid #ced4da;
        border-bottom: 1px solid #ced4da;
        border-top-right-radius: 0.2rem;
        border-bottom-right-radius: 0.2rem;
        cursor: pointer;
        transition: all 0.2ms;

        &:hover {
            color: #136d7b;
        }
    }
    .popover{
        opacity: 0.85;
        border-radius: 0.3rem;
    }
    .popover-body {
        background-color: rgba(0, 0, 0, 0.9);
        color: #ffffff;
        text-align: center;
        border-radius: 0.3rem;
    }
    .popover .arrow::before {
        border-top-color: rgba(0, 0, 0, 0.7);
        border-bottom-color: rgba(10, 9, 9, 0.7);
    }
    .popover .arrow::after {
        border-top-color: rgba(0, 0, 0, 0.7);
        border-bottom-color: rgba(0, 0, 0, 0.7);
    }
</style>
